import { createSelector } from '@ngrx/store';
import { EnrollmentState } from '../reducers/enrollment.reducer';
import { getRedeemCashV2State, RedeemCashV2State } from '../reducers/index';

const getEnrollmentState = createSelector(
  getRedeemCashV2State,
  (state: RedeemCashV2State) => state.enrollment,
);

const getError = (state: EnrollmentState) => state.error;
const getLoading = (state: EnrollmentState) => state.loading;
const getEnrollments = (state: EnrollmentState) => state.enrollments;

export const getEnrollmentEnrollments = createSelector(
  getEnrollmentState,
  getEnrollments,
);

export const getEnrollmentError = createSelector(getEnrollmentState, getError);

export const getEnrollmentLoading = createSelector(
  getEnrollmentState,
  getLoading,
);
